import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slider = () => {
    $(".js-slider__store").slick({
        dots: true,
        dotsClass: "pg-company-store__dots",
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        cssEase: "linear",
        arrows: false,
    });
};

const main = () => {
    slider();
};

export default main;
